<form [formGroup]="form" class="app-install-trigger-form profile-update-trigger-form">

  <app-flow-test-customer-section
    [group]="$any(form.get('accountAppUser'))"
    [modeOptions]="customerModeOptions"
    requirementLabel="Required"
    generateHint="A sandbox customer will be generated from the account catalog, then the profile update will be applied to that sandbox profile."
    cloneHint="Search for a real customer to clone into sandbox data. ProfileUpdate tests always run against a customer-centric sandbox profile."
    selectedHint="The selected customer's profile and identifiers will be copied into a sandbox customer before the profile update is applied. The real customer is never modified."
    [userSearchTerm]="userSearchTerm"
    [userSearchResults]="userSearchResults"
    [userSearchLoading]="userSearchLoading"
    [selectedUser]="selectedUser"
    (searchInput)="onUserSearchInput($event)"
    (userPicked)="pickUser($event)"
    (userCleared)="clearUser()"
  ></app-flow-test-customer-section>

  <section formGroupName="profileUpdate" class="section">
    <header class="section-header">
      <h4>Profile Update Payload</h4>
      <span class="hint">Required</span>
    </header>

    <div class="mode-toggle">
      <app-trigger-mode-radio-group
        formControlName="mode"
        [options]="profileUpdateModeOptions"
      ></app-trigger-mode-radio-group>
    </div>

    <p class="hint" *ngIf="profileUpdateMode === 'generate'">
      The runner will generate or clone a sandbox profile, apply a small
      sandbox-only update marker, and backdate the customer update timestamp
      for this flow's configured interval.
    </p>

    <div class="fields" *ngIf="profileUpdateMode === 'specify'">
      <div class="field profile-payload">
        <label>Profile JSON patch/body</label>
        <textarea
          [value]="profileJson"
          (input)="updateProfileJson($any($event.target).value)"
          rows="8"
          [class.invalid]="!profileJsonValid"
        ></textarea>
        <p class="hint" *ngIf="profileJsonValid">
          Provide a JSON object with profile fields to apply to the sandbox
          customer. For example, set <code>loyalty_tier</code> to
          <code>gold</code>.
        </p>
        <p class="hint error" *ngIf="!profileJsonValid">
          Profile update payload must be a valid JSON object.
        </p>
      </div>
    </div>
  </section>

  <app-flow-test-device-section
    [group]="$any(form.get('device'))"
    [modeOptions]="deviceModeOptions"
    requirementLabel="Optional"
    generateHint="A realistic sandbox device will be generated so flow conditions can read Device context when needed."
  ></app-flow-test-device-section>

  <app-flow-test-app-state-section
    [group]="$any(form.get('accountAppDevice'))"
    [modeOptions]="appStateModeOptions"
    [locationPermissionOptions]="locationPermissionOptions"
    requirementLabel="Optional"
  ></app-flow-test-app-state-section>
</form>
